<section [formGroup]="userForm">

    <mat-form-field>
        <mat-label> {{ 'collection.share.access.principals'|translate }}</mat-label>
        <input matInput [matAutocomplete]="auto" formControlName="search">
    </mat-form-field>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectUser($event)" [displayWith]="displayUser">
        @for (user of userSuggestions; track user.id) {
            <mat-option [value]="user">
                <span>{{ user.fullName }}</span>
            </mat-option>
        }
    </mat-autocomplete>
    @if (selectedUsers.length > 0) {
        <div class="share-access-selected-user-table">
            @for (user of selectedUsers; track user.id) {
              <div class="user">
                    <span>{{ user.fullName }}</span>
                    <span>
                        <button mat-icon-button (click)="removeUser(user)">
                            <mat-icon fontIcon="delete"></mat-icon>
                        </button>
                    </span>
                </div>
            }
        </div>
    }
    <mat-divider></mat-divider>
</section>

<section [formGroup]="permissionForm" [hidden]="!selectedUsers || selectedUsers.length === 0">
    <h3 class="mt-3 mb-3">{{ 'collection.share.access.permissions.hl'|translate }}</h3>
    <mat-form-field>
        <mat-label>{{ 'collection.share.access.permissions'|translate }}</mat-label>
        <mat-select formControlName="permission">
            <mat-option value="view">{{ 'collection.access.view'|translate }}</mat-option>
            <mat-option value="download">{{ 'collection.access.download'|translate }}</mat-option>
            <mat-option value="edit">{{ 'collection.access.edit'|translate }}</mat-option>
            <mat-option value="manage">{{ 'collection.access.manage'|translate }}</mat-option>
        </mat-select>
    </mat-form-field>
    <mat-divider></mat-divider>
</section>

<section [formGroup]="validForm" [hidden]="!selectedUsers || selectedUsers.length === 0">
    <h3 class="mt-3 mb-3">{{ 'collection.share.access.validity'|translate }}</h3>
    <div class="row">
        <div class="col-6">
            <mat-form-field>
                <mat-label>{{ 'collection.share.access.validfrom'|translate }}</mat-label>
                <input matInput [matDatepicker]="fromPicker" formControlName="validFrom">
                <mat-datepicker-toggle matIconSuffix [for]="fromPicker"></mat-datepicker-toggle>
                <mat-datepicker #fromPicker></mat-datepicker>
            </mat-form-field>
        </div>
        <div class="col-6">
            <mat-form-field>
                <mat-label>{{ 'collection.share.access.validfromtime'|translate }}</mat-label>
                <input matInput [matTimepicker]="fromTimePicker" formControlName="validFrom">
                <mat-timepicker-toggle matIconSuffix [for]="fromTimePicker"></mat-timepicker-toggle>
                <mat-timepicker #fromTimePicker></mat-timepicker>
            </mat-form-field>
        </div>
        <div class="col-6">
            <mat-form-field>
                <mat-label>{{ 'collection.share.access.validuntil'|translate }}</mat-label>
                <input matInput [matDatepicker]="untilPicker" formControlName="validUntil">
                <mat-datepicker-toggle matIconSuffix [for]="untilPicker"></mat-datepicker-toggle>
                <mat-datepicker #untilPicker></mat-datepicker>
            </mat-form-field>
        </div>
        <div class="col-6">
            <mat-form-field>
                <mat-label>{{ 'collection.share.access.validuntiltime'|translate }}</mat-label>
                <input matInput [matTimepicker]="untilTimePicker" formControlName="validUntil">
                <mat-timepicker-toggle matIconSuffix [for]="untilTimePicker"></mat-timepicker-toggle>
                <mat-timepicker #untilTimePicker></mat-timepicker>
            </mat-form-field>
        </div>
    </div>

</section>
<footer>
    <div class="btn-row mt-3">
        <button mat-button (click)="back.emit()">{{ 'button.cancel'|translate }}</button>
        <button mat-raised-button [disabled]="!selectedUsers || selectedUsers.length === 0" (click)="doShare()"> {{ 'collection.action.share'|translate }}</button>
    </div>
</footer>
